"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isBrowser = _interopRequireDefault(require("../../utils/is-browser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var prefixedProperty = _isBrowser["default"] ? require('vendor-prefix').dash('transform') : 'transform';
var transformTemplates = {
  translateX: function translateX(value) {
    return "translateX(".concat(value, "px)");
  },
  translate3d: function translate3d(value) {
    return "translate3d(".concat(value, "px, 0, 0)");
  }
};
var _default = exports["default"] = function _default() {
  if (!_isBrowser["default"] || !window.CSS || !window.CSS.supports) {
    return {
      property: prefixedProperty,
      getValue: transformTemplates.translateX
    };
  }
  var supports3dTransforms = window.CSS.supports(prefixedProperty, 'translate3d(0,0,0)');
  return {
    property: prefixedProperty,
    getValue: transformTemplates[supports3dTransforms ? 'translate3d' : 'translateX']
  };
};